import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from 'api/api';

export const getPaymentMethods = createAsyncThunk(
  'paymentMethods/getPaymentMethods',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get('/payment-methods', { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Не вдалося отримати способи оплати');
    }
  }
);

const paymentMethodsSlice = createSlice({
  name: 'paymentMethods',
  initialState: {
    paymentMethods: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentMethods.pending, (state, action) => {
        state.isLoading = true;
        state.paymentMethods = [];
        state.error = null;
      })
      .addCase(getPaymentMethods.fulfilled, (state, action) => {
        state.isLoading = false;
        state.paymentMethods = action.payload;
      })
      .addCase(getPaymentMethods.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default paymentMethodsSlice.reducer;
